import api from "../store/services/api";

export const getDeliveryHeatmap = async (params) =>
  await api.get("/delivery-analytics/delivery-heatmap/", { params });

export const getMicroMarketAnalysis = async (params) =>
  await api.get("/delivery-analytics/micro-market-analysis/", { params });

export const getAllAnalyticsData = async (params) =>
  await api.get("/delivery-analytics/all-data/", { params });

export const exportAnalyticsToCSV = async (endpoint, params) =>
  await api.get(`/delivery-analytics/${endpoint}/export/`, {
    params,
    responseType: "blob",
  });

export const generateAnalyticsPDF = async (endpoint, params) =>
  await api.get(`/delivery-analytics/${endpoint}/pdf/`, {
    params,
    responseType: "blob",
  });

export const saveCustomDashboard = async (dashboardConfig) =>
  await api.post("/delivery-analytics/dashboards/", dashboardConfig, {
    headers: { "Content-Type": "application/json" },
  });

export const getSavedDashboards = async () =>
  await api.get("/delivery-analytics/dashboards/");

export const getAnalyticsByEndpoint = async (endpoint, params) =>
  await api.get(`/delivery-analytics/${endpoint}/`, { params });

export const getOrderDistribution = async (params) =>
  await api.get("/order-distribution/", { params });

export const getDeliveryTeamStats = async (params) =>
  await api.get("/delivery-team-stats/", { params });

export const getLateOrderStats = async (params) =>
  await api.get("/late-orders-stats/", { params });

export const getDeliveryServiceStats = async (params) =>
  await api.get("/delivery-service-stats/", { params });

export const getDriverPerformance = async (params) =>
  await api.get("/driver-performance/", { params });

export const getDeliveryByRadius = async (params) =>
  await api.get("/delivery-by-radius/", { params });

const DeliveryAnalyticsService = {
  getDeliveryHeatmap,
  getMicroMarketAnalysis,
  getOrderDistribution,
  getDeliveryTeamStats,
  getLateOrderStats,
  getDeliveryServiceStats,
  getAllAnalyticsData,
  getDriverPerformance,
  getDeliveryByRadius,
  exportAnalyticsToCSV,
  generateAnalyticsPDF,
  saveCustomDashboard,
  getSavedDashboards,
  getAnalyticsByEndpoint,
};

export default DeliveryAnalyticsService;
